import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppBreadcrumb,
  AppFooter,
  AppHeader
} from '@coreui/react';
// routes config
import routes from '../../routes_agent';
import AgentHeader from './AgentHeader';

class AgentLayout extends Component {
  render() {
    return (
      <div className="app">
        <AppHeader fixed>
          <AgentHeader />
        </AppHeader>
        <div className="app-body">
          <main className="main">
            <AppBreadcrumb appRoutes={routes}/>
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                    return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                        <route.component {...props} />
                      )} />)
                      : (null);
                  },
                )}
                <Redirect from="/" to="/outcomes" />
              </Switch>
            </Container>
          </main>
        </div>
        <AppFooter>
        </AppFooter>
      </div>
    );
  }
}

export default AgentLayout;
